"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const dashboard_widget_styles_1 = require("./dashboard-widget.styles");
const DashboardWidget = ({ title, className, children }) => (react_1.default.createElement(dashboard_widget_styles_1.StyledDashboardWidgetWrapper, { className: className }, typeof title === 'string'
    ? react_1.default.createElement(dashboard_widget_styles_1.StyledDashboardWidgetTitle, { transform: "uppercase", variant: "h6" }, title)
    : title, react_1.default.createElement("div", { className: "widget-content" }, children)));
exports.default = DashboardWidget;
